
import * as Mutations from './mutations'

const state = {
  isLogined: false
}

const getters = {
}

const mutations = {
  [Mutations.login] (state, payload) {
    console.log(`Login ...`)
    state.isLogined = payload.type
    console.log(state.isLogined)
  }
  // [Mutations.logout] (state) {
  //   console.log(`Logout ...`)
  //   state.isLogined = false
  //   console.log(`Logout ...`)
  // }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/root.js